export default [
     {
          path: '/lectures',
          name: 'lectures',
         component: () => import("@/views/Page/Lectures/Lectures.vue"),
           meta: {
               title: '#Default# | lectures',
          },
     },
     {
          path: '/lectures/attendance/:section_id/:schedule_id',
          name: 'lectures-attendance',
          component: () => import("@/views/Page/Lectures/Attendance.vue"),
          props: true,
          meta: {
               title: '#Default# | Attendance',
          },
     }
];

